export var ContainsFilter;
(function (ContainsFilter) {
    /**
     * Filter type.
     */
    let type;
    (function (type) {
        type["CONTAINS"] = "contains";
    })(type = ContainsFilter.type || (ContainsFilter.type = {}));
})(ContainsFilter || (ContainsFilter = {}));
